<template>
  <div class="card">
    <v-form>
      <div class="Login-title mb-1">
        <v-icon class="mr-1" @click="$router.push('/forgetpassword')"
          >mdi mdi-chevron-left</v-icon
        >
        Forgot your password?
      </div>
      <div class="img-wrapper">
        <img
          :src="require('../assets/otp.svg')"
          alt="Forgot Password"
          style="height: 125px; width: 140px"
        />
      </div>

      <div class="text-wrapper pl-1">
        <p class="instructions">Please enter the Verification Code.</p>
        <p class="instructions-text">
          Enter the 6-digit verification code sent to your Email ID
          sr*****27@gmail.com
        </p>
      </div>

      <div class="otp-container mb-2">
        <v-text-field
          v-for="n in 6"
          :key="n"
          class="otp-box custom-text-field"
          v-model="otp[n - 1]"
          maxlength="1"
          variant="outlined"
          density="compact"
          hide-details
        ></v-text-field>
      </div>
      <div class="pl-1 receive">
        Didn’t receive the email?
        <a @click="resend" class="resend">Click here </a> to resend.
      </div>
      <div class="pl-1">
        <v-btn
          color="#D0103A"
          block
          size="large"
          :loading="loading"
          class="log-btn text-white mt-3"
          @click="verify"
        >
          Verify
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      otp: Array(6).fill(""),
      loading: false,
    };
  },
  methods: {
    async resend() {},
    async verify() {},
  },
};
</script>
<style scoped>
.Login-title {
  font-size: 16px;
  font-weight: 500;
}

.img-wrapper {
  display: flex;
  justify-content: center;
}

.img-wrapper img {
  width: 100%;
  height: 150px;
  max-width: 200px;
}

.text-wrapper {
  margin-bottom: 16px;
}

.instructions {
  font-size: 13px;
  color: #565656;
  margin: 0;
}

.instructions-text {
  font-size: 11px;
  color: #686868;
  /* margin: 4px 0 0 0; */
}

.log-btn {
  font-weight: 600;
  border-radius: 4px;
  /* margin-top: 16px; */
}

.custom-text-field {
  margin-top: 12px;
}

>>> .v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon,
.v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon,
.v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
  color: #5e5f60 !important;
}

.otp-container {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.otp-box {
  width: 45px;
  text-align: center;
}
</style>
